import Vue from 'vue'
import Vuex from 'vuex'
import users from "./users"
import gamelog from "./gamelog";
import coachs from "./coachs";
import juegos from "./juegos";
import jugadores from "./jugadores";
import jugadoresncaa from "./jugadoresncaa";
import lideres from "./lideres";
import lideresindividual from "./lideresindividual";
import rivales from "./rivales";
import teamrecords from "./teamrecords";
import torneos from "./torneos";
import {auth} from "../firebase"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
    checkAuth({ commit }) {
      auth.onAuthStateChanged(function(user) {
        if (user) {
          commit("users/setUser", user);
        } else {
          commit("users/setUser", null);
        }
      });
    }
  },
  modules: {
    users,
    gamelog,
    coachs,
    juegos,
    jugadores,
    jugadoresncaa,
    lideres,
    lideresindividual,
    rivales,
    teamrecords,
    torneos
  }
})
